
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"31","viewBox":"0 0 16 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.878 7.6a1 1 0 00-.89-.55h-5v-6A1 1 0 008.679.048a1 1 0 00-.501.362l-8 11a1 1 0 00-.08 1 1 1 0 00.89.64h5v6a1 1 0 001.454.892 1 1 0 00.356-.302l8-11a1 1 0 00.08-1.04zm-7.89 8.37v-3.92a1 1 0 00-1-1h-4l5-6.92v3.92a1 1 0 001 1h4l-5 6.92z","fill":"#D8F3DC"}})])
          )
        }
      }
    